<template>
	<div>
		<v-container class="pt-2">
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" class="pt-0">
					<v-expansion-panels>
						<v-expansion-panel>
							<v-expansion-panel-header disable-icon-rotate>
								<template #default="{ open }">
									<v-row no-gutters class="text-center">
										<v-col cols="12" class="text--secondary">
											<v-fade-transition leave-absolute>
												<span v-if="open" key="0">
													التصفية
													<v-icon color="primary" left>mdi-filter</v-icon>
												</span>
												<span v-else key="1">
													التصفية
													<v-icon color="primary" left>mdi-filter</v-icon>
												</span>
											</v-fade-transition>
										</v-col>
									</v-row>
								</template>
								<template #actions>
									<v-icon color="primary"></v-icon>
								</template>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row justify="center" dense>
									<v-col cols="12" md="4">
										<v-select
											v-model="filters.stateID"
											hide-details
											outlined
											label="الحالة"
											:items="states"
											item-text="name"
											item-value="stateID"
											clearable
										></v-select>
									</v-col>
									<v-col cols="12" md="4">
										<v-select
											v-model="filters.parentID"
											hide-details
											outlined
											label="المجموعة الأب"
											:items="allGroups"
											item-text="name"
											item-value="userGroupID"
											clearable
										></v-select>
									</v-col>
									<v-col cols="12" md="4">
										<v-select
											v-model="filters.itemsPerPage"
											hide-details
											outlined
											label="عدد المجموعات في الصفحة"
											:items="itemsPerPage"
										></v-select>
									</v-col>
									<v-col cols="12" class="text-center">
										<v-btn color="success" @click="applyFilter">تصفية</v-btn>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
			</v-row>

			<v-data-table
				id="content"
				:headers="headers"
				:items="groups"
				class="elevation-1"
				item-key="id"
				hide-default-footer
				:items-per-page="-1"
				:loading="loading"
			>
				<template #top>
					<v-toolbar flat>
						<v-toolbar-title class="px-4">المجموعات</v-toolbar-title>
						<v-divider inset vertical></v-divider>
						<v-spacer></v-spacer>
						<v-btn color="primary" :disabled="!privs.new" @click="showAddGroup">مجموعة جديدة</v-btn>
					</v-toolbar>
				</template>

				<template #[`item.name`]="{ item }">
					<router-link :to="'/users/grouppage/' + item.userGroupID" class="primary--text">{{ item.name }}</router-link>
				</template>

				<template #[`item.stateID`]="{ item }">
					{{ item.state ? item.state.name : '' }}
				</template>

				<template #[`item.actions`]="{ item }">
					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn icon color="primary" :disabled="!privs['editUsers']" v-on="on" @click="showUpdateGroup(item)">
								<v-icon>mdi-account-edit</v-icon>
							</v-btn>
						</template>

						<span>تحرير</span>
					</v-tooltip>

					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn icon color="primary" :disabled="!privs['editUsers']" v-on="on" @click="deleteGroup(item)">
								<v-icon medium>mdi-trash-can-outline</v-icon>
							</v-btn>
						</template>
						<span>حذف</span>
					</v-tooltip>
				</template>
			</v-data-table>
			
			<div class="text-center pt-2">
				<v-pagination v-model="page" :length="pageCount"></v-pagination>
			</div>
		</v-container>

		<v-dialog v-model="addGroupDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة مجموعة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form ref="addGroupForm" v-model="valid1">
						<v-row dense>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field
									v-model="newGroup.id"
									outlined
									label="معرف المجموعة"
									dir="ltr"
									:rules="[rules.required, rules.id]"
								></v-text-field>
							</v-col>

							<v-col cols="12" md="6" class="py-0">
								<v-text-field
									v-model="newGroup.name"
									outlined
									label="اسم المجموعة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newGroup.description"
									outlined
									label="الوصف"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" md="6" class="py-0">
								<v-select
									v-model="newGroup.parentId"
									outlined
									label="المجموعة الأب"
									:items="groups"
									item-text="name"
									item-value="userGroupID"
									clearable
								></v-select>
							</v-col>

							<v-col cols="12" md="6" class="py-0">
								<v-select
									v-model="newGroup.stateID"
									outlined
									label="الحالة"
									:items="states"
									item-text="name"
									item-value="stateID"
									:rules="[rules.required]"
								></v-select>
							</v-col>

							<v-col v-if="error" cols="12">
								<v-alert type="error">خطأ</v-alert>
							</v-col>

							<v-col cols="12" class="text-center" @mouseover="validateAddGroup">
								<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="addNewGroup">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="updateGroupDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث بيانات المجموعة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form ref="updateGroupForm" v-model="valid2">
						<v-row dense>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field
									v-model="updatingGroup.name"
									outlined
									label="اسم المجموعة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" md="6" class="py-0">
								<v-text-field
									v-model="updatingGroup.description"
									outlined
									label="وصف المجموعة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" md="6" class="py-0">
								<v-select
									v-model="updatingGroup.parentID"
									outlined
									label="المجموعة الأب"
									:items="groups"
									item-text="name"
									item-value="userGroupID"
									clearable
								></v-select>
							</v-col>

							<v-col cols="12" md="6" class="py-0">
								<v-select
									v-model="updatingGroup.stateID"
									outlined
									label="الحالة"
									:items="states"
									item-text="name"
									item-value="stateID"
									:rules="[rules.required]"
								></v-select>
							</v-col>

							<v-col v-if="error" cols="12">
								<v-alert type="error">Error</v-alert>
							</v-col>

							<v-col cols="12" class="text-center" @mouseover="validateUpdateGroup">
								<v-btn color="primary" :disabled="!valid2" :loading="loading" @click="updateGroup">تحديث</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="deletConfirmationDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تأكيد الحذف</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form ref="confirmationForm">
						<v-row dense class="text-center">
							<v-col cols="6" class="text-center">
								<v-btn color="primary" :loading="loading" @click="deleteGroupConfirmed">حذف</v-btn>
							</v-col>

							<v-col cols="6" class="text-center">
								<v-btn color="primary" :loading="loading" @click="deletConfirmationDialog = false">رجوع</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'المجموعات', disabled: true }
			],
			headers: [
				{ text: "اسم المجموعة", value: "name", sortable: false },
				{ text: "وصف المجموعة", value: "description", sortable: false },
				{ text: "المجموعة الأب", value: "parentName", sortable: false },
				{ text: "الحالة", value: "stateID", sortable: false },
				{ text: "العمليات", value: "actions", sortable: false }
			],
			page: 1,
			pageCount: 1,
			loading: false,
			error: false,
			valid1: false,
			valid2: false,
			addGroupDialog: false,
			updateGroupDialog: false,
			newGroup: {
				id: "",
				name: "",
				description: "",
				parentId: null,
				stateID: null
			},
			updatingGroup: {
				userGroupID: "",
				name: "",
				description: "",
				parentID: null,
				stateID: null
			},
			groups: [],
			deletConfirmationDialog: false,
			deletingUserGroupID: null,
			states: [],
			allGroups: [],
			filters: {
				stateID: null,
				parentID: null,
				itemsPerPage: 10,
			},
			itemsPerPage: [10, 20, 30, 40, 50],
			storedFilters: {
				itemsPerPage: 10
			},
		};
	},
	watch: {
		page(newVal) {
			this.getGroups(newVal);
			this.$vuetify.goTo('#content');
		}
	},
	mounted() {
		this.getPrivileges();
		this.getGroups(1);
		this.getStates();
		this.getAllGroups();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/groupIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getStates() {
			client
				.post("/api/users/getstates", {})
				.then(response => {
					console.log(response);
					this.states = response.data.data.filter(state => state.stateID != 'deleted');
				})
				.catch(err => {
					console.log(err);
				});
		},
		applyFilter() {
			this.storedFilters = { ...this.filters };
			this.groups = [];
			this.loading = true;
			this.getGroups(1);
		},
		getGroups(page) {
			this.loading = true;
			this.groups = [];

			client
				.post("/api/usergroups/getall?page=" + page, this.storedFilters)
				.then(response => {
					console.log(response);
					this.pageCount = response.data.data.last_page;
					this.groups = Object.values(response.data.data.data).map(group => {
						if (group.state) {
							group.stateID = group.state.stateID;
						}
						return group;
					});
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getAllGroups() {
			client
				.post("/api/usergroups/getall", { itemsPerPage: 99999 })
				.then(response => {
					console.log(response);
					this.allGroups = response.data.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		showAddGroup() {
			this.addGroupDialog = true;
		},
		showUpdateGroup(usergroup) {
			this.updatingGroup = { ...usergroup };
			this.updateGroupDialog = true;
		},
		validateAddGroup() {
			this.$refs.addGroupForm.validate();
		},
		validateUpdateGroup() {
			this.$refs.updateGroupForm.validate();
		},
		addNewGroup() {
			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			let data = new FormData();
			data.append("userGroupID", this.newGroup.id);
			data.append("name", this.newGroup.name);
			data.append("description", this.newGroup.description);
			data.append("stateID", this.newGroup.stateID);

			if (this.newGroup.parentId) {
				data.append("parentID", this.newGroup.parentId);
			}

			this.loading = true;
			this.error = false;
			client
				.post("/api/usergroups/addnewgroup", data, config)
				.then(response => {
					console.log(response);
					// this.newGroup.userGroupID = this.newGroup.id;
					// this.newGroup.parentID = this.newGroup.parentId;
					// this.groups.push({ ...this.newGroup });
					this.getGroups(this.page);
					this.addGroupDialog = false;
					this.$store.dispatch("notify", { message: "تمت عملية اضافة مجموعة جديدة بنجاح" });
				})
				.catch(err => {
					console.log(err);
					this.error = true;
					var errors = err.response.data.errors;

					const ERROR_TAKEN_GROUP_ID =
						"The user group i d has already been taken.";
					
					if (errors.userGroupID[0] == ERROR_TAKEN_GROUP_ID) {
						this.$store.dispatch("notify", { message: "معرف المجموعة مستخدم, الرجاء اختيار معرف مجموعة اخر", color: "error" });
					} else {
						this.$store.dispatch("notify", { message: "فشلت عملية اضافة مجموعة جديدة", color: "error" });
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateGroup() {
			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			let data = new FormData();
			data.append("userGroupID", this.updatingGroup.userGroupID);
			data.append("name", this.updatingGroup.name);
			data.append("description", this.updatingGroup.description);
			data.append("stateID", this.updatingGroup.stateID);

			if (this.updatingGroup.parentID) {
				data.append("parentID", this.updatingGroup.parentID);
			}

			this.loading = true;
			this.error = false;
			client
				.post("/api/usergroups/update", data, config)
				.then(response => {
					console.log(response);
					// var index = this.groups.findIndex(
					// 	group =>
					// 		group.userGroupID == this.updatingGroup.userGroupID
					// );
					// this.groups.splice(index, 1);
					// const newState = this.states.find(state => this.updatingGroup.stateID == state.stateID)
					// this.updatingGroup.state = newState;
					// this.groups.push({ ...this.updatingGroup });
					this.getGroups(this.page);
					this.updateGroupDialog = false;
					this.$store.dispatch("notify", { message: "تمت عملية تحديث المجموعة بنجاح" });
				})
				.catch(err => {
					console.log(err);
					this.error = true;
					this.$store.dispatch("notify", { message: "فشلت عملية تحديث المجموعة", color: "error" });
				})
				.finally(() => {
					this.loading = false;
				});
		},
		deleteGroup(userGroup) {
			this.deletingUserGroupID = userGroup.userGroupID;
			this.deletConfirmationDialog = true;
		},
		deleteGroupConfirmed() {
			this.loading = true;
			clientNotifier
				.delete("/api/usergroups/delete/" + this.deletingUserGroupID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					// var index = this.groups.findIndex(
					// 	group => group.userGroupID == this.deletingUserGroupID
					// );
					// this.groups.splice(index, 1);
					this.getGroups(this.page);
					this.deletConfirmationDialog = false;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>